/* eslint-disable prettier/prettier */
// --- actions do site
export const FETCH_PREVIEW_URL = "fetchPreviewUrl";
export const SEND_CONTACT_EMAIL = "sendContactEmail";

// --- actions da aplicação
export const ADD_TOOLBAR_TITLE = "addToolbarTitle";
export const SHOW_SOLICITACOES_SHEET = "showSolicitacoesSheet";
export const SHOW_OVERLAY = "showOverlay";
export const MSG_ALERT = "msgAlert";
export const MSG_CONFIRM = "msgConfirm";
export const MSG_NOTIFICATION = "msgNotification";
export const CLEAR_ALL_MSG = "clearAllMsg";

// --- actions de authentication e authorization (logado)
export const LOGIN = "login";
export const INIT_KEYCLOAK = "initKeycloak";
export const INIT_APIS = "initApis";
export const SET_KEYCLOAK = "setKeycloak";
export const SET_TOKEN = "setToken";
export const SELECT_GROUP = "selectGroup";
export const UPDATE_TOKEN = "updateToken";
export const MY_ACCOUNT_REDIRECT = "myAccountRedirect";
export const LOGOUT = "logout";
export const USER_CREATE = "userCreate";
export const USER_DESTROY = "userDestroy";

// --- actions padrão para entidades
export const FETCH_ALL = "fetchAll"; // api list

export const FETCH = "fetch"; // api get/id
export const FETCH_DOCUMENTOS = "fetchDocumentos";
export const DISCARD_CHANGES = "discardChanges"; // descarta alterações antes de salvar
export const SAVE = "save"; // api add
export const DELETE = "delete"; // api delete/id

// --- actions específicas
export const ADD_DISCIPLINA = "addDisciplina";
export const REMOVE_DISCIPLINA = "removeDisciplina";
export const REMOVE_OBSERVACOES = "removeObservacoes";
export const REMOVE_ALL_DISCIPLINAS = "removeAllDisciplinas";
export const SEND_SOLICITACAO_EMAIL = "sendSolicitacaoEmail";
export const SEND_RENT = "sendRent";

// -- actions de dashboard
export const FETCH_DASHBOARD_DISCIPLINA = "fetchDashboardDisciplina";
export const FETCH_DASHBOARD_CURSO = "fetchDashboardCurso";
export const FETCH_DASHBOARD_EDUCASPACE = "fetchDashboardEducaspace";
export const FETCH_DASHBOARD_ALUNO_ACCESS = "fetchDashboardAlunoAccess";
export const FETCH_DASHBOARD_CATALOGO = "fetchDashboardCatalogo";
export const FETCH_DASHBOARD_LISTA_EDUCASPACE = "fetchDashboardListaEducaspace";
export const FETCH_DASHBOARD_NOVIDADE = "fetchDashboardNovidade";
export const FETCH_DASHBOARD_RENTS_TIMELINE = "fetchDashboardRentsTimeline";
export const FETCH_DASHBOARD_PERCENTAGE = "fetchDashboardPercentage";
export const FETCH_DASHBOARD_BLOG = "fetchDashboardBlog";
export const CLEAR_ALL = "clearAll"; // pode ser usado para limpar filtros
export const FETCH_FOR_URL_PREVIEW = "fetchForUrlPreview";
export const FETCH_LINE_CHART = "fetchLineChart";
export const FETCH_ORIGENS = "fetchOrigens";
//pusher
export const INIT_PUSHER = "initPusher";
export const BIND_PUSHER = "bindPusher";

export const ADD_NOTIFICATION = "addNotification";
export const CLEAR_ALL_NOTIFICATION = "clearAllNotification";

export const FETCH_ALL_USO_COBRANCAS = "fetchAllUsoCobrancas";
//params
export const FETCH_ALL_ORGANIZATIONS_PARAMS = "fetchAllOrganizationsParams";

export const FETCH_ALL_ORGANIZATIONS_LITE = "fetchAllOrganizationsLite";

export const SAVE_CUSTOMER = "saveCustomer";

export const CREATE_UPDATE_CUSTOMER = "createUpdateCustomer";

export const BASE = "base";

export const FETCH_FORNECEDOR_PLANOS = "fetchFornecedorPlanos";

export const GET_CUSTOMER_ID = "getCustomerId";

export const UPDATE_PLANO = "updatePlano";

export const SAVE_DOCUMENT = "saveDocument";

export const SET_DOCUMENT = "setDocument";

export const SIGN_URL = "signUrl";

export const FETCH_ORGANIZATION_PARAMS = "fetchOrganizationParams";

export const FETCH_ALL_EMENTA_PDF = "fetchAllEmentaPdf";         // api list pdf ementa

// action auto-complete server-side
export const AUTO_COMPLETE_CLEAR_ALL = "autoCompleteClearAll";
export const AUTO_COMPLETE_FETCH_ALL = "autoCompleteFetchAll";

// actions auto complete cliente side
export const AUTO_COMPLETE_CLIENT_SIDE_FETCH_ALL = "autoCompleteClientSideFetchAll";

//actions editar parametros
export const FETCH_PARAMETROS = "fetchParametros";
export const UPDATE_PARAMETROS ="updateParametros";

//actions curso categorias:
export const FETCH_ALL_CURSO_CATEGORIAS = "fetchAllCursoCategorias"; 


//actions para organizations
export const FETCH_ALL_ORGANIZATION_FORNECEDORAS = "fetchAllOrganizationFornecedoras"; // api get/id

export const FETCH_ALL_ORGANIZATION_CLIENTES = "fetchAllOrganizationClientes";

//actions relatorios
export const FETCH_ALL_ROYALTIES_RELATORIO = "fetchAllRoyaltiesRelatorio";

//actions para acervos
export const LIMPAR_ACERVOS = "limparAcervos";

export const PLATFORM_GROUP = "platformGroup";

export const FETCH_ALL_PDF = "fetchAllPdf";
export const FETCH_ALL_CSV = "fetchAllCsv";


export const DEFAULT_USUARIO = "defaultUsuario";


//actions TI
export const FORCE_COBRANCAS = "forceCobrancas";

export const SYNC_UNIDADES_FORNECEDORES = "syncUnidadesFornecedores";

export const SYNC_DISCIPLINAS = "syncDisciplinas";

export const FETCH_UNIDADES_FORNECEDOR_ZERADO = "fetchUnidadesFornecedorZerado";

export const FETCH_ALL_GROUPS_KEYCLOAK = "fetchAllGroupsKeycloak";
export const SAVE_LEAD = "saveLead";